<template>
	<div class="c-body">
		<div class="c-body__title">
			<h2>このサイトについて</h2>
		</div>
		<div class="c-body__inner">
			<div class="e-grid -triple">
				<div class="col -double">
					<div class="e-section">
						<h3>Codogue [コドーグ]</h3>
						<p>
							このサイトは、わざわざ自作する程でもないちょこざいな小道具の置き場です。
							作者が欲しいなと思った物を作っては出し、作っては出し、時には葬ったりしています。
						</p>
						<p>
							実験室を兼ねているので、不具合もあるかもしれません。
							そんな時は、気兼ねなく作者まで連絡を飛ばしてください。
						</p>
					</div>
					<hr class="e-hr">
					<div class="e-section">
						<h3>推奨環境</h3>
						<p>
							各ブラウザの最新バージョンでご利用ください。
							レガシーな環境での動作保証はいたしかねます。
						</p>
						<ul>
							<li>Chrome 最新版</li>
							<li>Firefox 最新版</li>
							<li>Edge / IE 11+</li>
						</ul>
					</div>
					<hr class="e-hr">
					<div class="e-section">
						<h3>免責事項</h3>
						<ul>
							<li>本サイトのツールを使用するにあたって如何なるアクシデントや障害が生じたとしても、 当方は一切の責任を負うことは出来ません。</li>
							<li>ツール・ならびにサイトの内容は予告なしに変更が加えられる事があります。</li>
						</ul>
					</div>
				</div>
				<div class="col">
					<div class="e-section">
						<h3>連絡先</h3>
						<ul>
							<li><a href="https://twitter.com/codogue">@codogue</a></li>
							<li><a href="https://twitter.com/mach3ss">@mach3ss</a></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import mCommon from "../mixins/common";

export default {
	mixins: [
		mCommon
	],
	data(){
		return {
		}
	}
}
	
</script>



// WEBPACK FOOTER //
// about.vue?4c3d7097